import React from "react";

import { BaseField } from "../types";
import { Input } from "../../Input";
import { FieldGroup, Label, HelperText } from "../shared";
import { useTheme } from "../../../theme";

interface TextFieldProps {
  field: BaseField & { type: "text" | "email" | "number" | "tel" };
  value: string;
  onChange: (value: string) => void;
}

export const TextField: React.FC<TextFieldProps> = ({
  field,
  value,
  onChange,
}) => {
  const theme = useTheme();

  return (
    <FieldGroup>
      <Label htmlFor={field.id}>
        {field.label}
        {field.required && (
          <span style={{ color: theme.colors.warn }} aria-label="required">
            {" "}
            *
          </span>
        )}
      </Label>
      {field.helpText && (
        <HelperText id={`${field.id}-help`}>{field.helpText}</HelperText>
      )}
      <Input
        id={field.id}
        type={field.type}
        size="md"
        value={value}
        placeholder={field.placeholder}
        // Allows only digits, spaces, plus sign, parentheses, hyphens
        pattern={field.type === "tel" ? "[\\d\\s\\-\\+\\(\\)]+" : undefined}
        onValueChange={(v) => {
          let cleanedValue = v;
          if (field.type === "tel") {
            cleanedValue = v.replace(/[^\d\s\-+()]/g, "");
          } else if (field.type === "email") {
            cleanedValue = v.replace(/\s/g, "");
          }
          onChange(cleanedValue);
        }}
        aria-required={field.required}
        aria-describedby={field.helpText ? `${field.id}-help` : undefined}
      />
    </FieldGroup>
  );
};
